import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Button, Divider, message } from 'antd'
import ReceivableTable from './ReceivableTable'
import PosPayment from '../PosPayment'
import PosSrc from '../../PosSrc'
import { Context } from '../../../../context'

function ReceivableIndex(props) {
  const [_, dispatch] = useContext(Context)
  const [payStatus, setPayStatus] = useState(false)
  const [completeSell, setCompleteSell] = useState(false)
  const [sellInfo, setSellInfo] = useState([])
  const [loadingSell, setLoadingSell] = useState(false)
  const [symbol, setSymbol] = useState('')
  const [companyId, setCompanyId] = useState('')

  const payInfo = row => {
    setSellInfo(row)
    setPayStatus(true)
  }

  useEffect(() => {
    async function fetchData() {
      const store = await PosSrc.getStore(props.store.id)
      setSymbol(store.company.currency.symbol)
      setCompanyId(store.company.id)
    }

    fetchData()  
    // eslint-disable-next-line  
  }, [])

  const paySell = (data, sellId) => {
    setCompleteSell(false)
    setLoadingSell(true)
    PosSrc.completeSell(sellId, data)
      .then(res => {
        if (res?.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
          setLoadingSell(false)
        } else {
          message.success('Se ha guardado el pago exitosamente')
          getCash(res.sell.store_id)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido guardar el pago')
        setLoadingSell(false)
      })
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      switch (key) {
        case 'phone':
          message.error(res.errors[key][0].replace('phone', 'Teléfono'))
          break
        case 'nit':
          message.error(res.errors[key][0].replace('nit', 'NIT'))
          break
        case 'description':
          message.error(res.errors[key][0].replace('description', 'Descripción'))
          break
        case 'name':
          message.error(res.errors[key][0].replace('name', 'Nombre'))
          break
        case 'email':
          message.error(res.errors[key][0].replace('email', 'Correo Electrónico '))
          break
        default:
          message.error(res.errors[key])
          break
      }
      return null
    })
  }

  const getCash = id => {
    PosSrc.getStoreCash(id).then(response => {
      dispatch({
        type: 'TURN CASH',
        payload: response.data[0],
      })
      setLoadingSell(false)
      setPayStatus(false)
    })
  }

  return (
    <>
      <Row gutter={16} className={'sell-row'}>
        <Col xs={24} sm={24} md={24} lg={24}>
          {!payStatus ? (
            <ReceivableTable setQuotationData={props.setQuotationData} activeKey={props.activeKey} completeSell={completeSell} pay={payInfo} store={props.store} />
          ) : (
            <PosPayment
              edit={true}
              sellUncompleted={_ => setCompleteSell(false)}
              sellInfo={sellInfo}
              completeSell={completeSell}
              store={props.store}
              turn={props.turn}
              paySell={paySell}
              symbol={symbol}
              companyId={companyId}
              paymentMethods={props.paymentMethods}
            />
          )}
        </Col>
        {payStatus && (
          <>
            <Divider className={'divider-custom-margins-users'} />
            <Col sm={24}>
              <div className="pay-buttons">
                <Button type={'link'} className="cancel-button" onClick={() => setPayStatus(false)}>
                  Cancelar
                </Button>
                <Button loading={loadingSell} htmlType="submit" className="title-tendero new-button" onClick={() => setCompleteSell(true)}>
                  Finalizar pago
                </Button>
              </div>
            </Col>
          </>
        )}
      </Row>
    </>
  )
}

export default ReceivableIndex
